import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

const NAME_REGEX = /^[A-Za-zÄÖÜäöüß\s-]+$/;

export const germanNameValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = String(control.value ?? '').trim();
  if (!value) {
    return null;
  }
  return NAME_REGEX.test(value) ? null : {germanName: true};
};

export const emailMatchValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const email = control.get('email')?.value;
  const emailRepeat = control.get('emailRepeat')?.value;
  if (!email || !emailRepeat) {
    return null;
  }
  return email === emailRepeat ? null : {emailMismatch: true};
};
